import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.tc(_vm.operatingStatusText[_vm.mode]) + _vm.t('原标商品映射'),
      "width": 700,
      "wrap-class-name": "modal-body"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formDataRule,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7F16\u7801"),
      "prop": "product_sku",
      "label": _vm.t('商品编码')
    }
  }, [_c('request-auto-complete', {
    directives: [{
      name: "uppercase",
      rawName: "v-uppercase",
      value: _vm.formData.product_sku,
      expression: "formData.product_sku"
    }],
    attrs: {
      "searchFunction": _vm.handleSearchSkuList,
      "disabled": _vm.isEdit
    },
    scopedSlots: _vm._u([{
      key: "dataSource",
      fn: function (ref) {
        var options = ref.options;
        return _vm._l(options, function (item) {
          return _c('a-select-option', {
            key: item.sku,
            attrs: {
              "value": item.sku
            }
          }, [_vm._v(_vm._s(item.sku))]);
        });
      }
    }]),
    model: {
      value: _vm.formData.product_sku,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "product_sku", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.product_sku"
    }
  })], 1), _c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "bordered": "",
      "data-source": _vm.formData.mapping_list,
      "row-key": "_rowKey"
    },
    scopedSlots: _vm._u([{
      key: "product_sku",
      fn: function (ref) {
        var row = ref.row;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "mapping_list." + index + ".relation_barcode",
            "rules": _vm.formDataRule['mapping_list.*.relation_barcode']
          }
        }, [_c('a-input', {
          directives: [{
            name: "uppercase",
            rawName: "v-uppercase",
            value: row.relation_barcode,
            expression: "row.relation_barcode"
          }],
          attrs: {
            "disabled": _vm.isEdit
          },
          model: {
            value: row.relation_barcode,
            callback: function ($$v) {
              _vm.$set(row, "relation_barcode", $$v);
            },
            expression: "row.relation_barcode"
          }
        })], 1)];
      }
    }, {
      key: "third_part_platform",
      fn: function (ref) {
        var row = ref.row;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "mapping_list." + index + ".third_part_platform",
            "rules": _vm.formDataRule['mapping_list.*.third_part_platform']
          }
        }, [_c('a-input', {
          model: {
            value: row.third_part_platform,
            callback: function ($$v) {
              _vm.$set(row, "third_part_platform", $$v);
            },
            expression: "row.third_part_platform"
          }
        })], 1)];
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var index = ref.index;
        return _c('my-operation', {}, [index > 0 || _vm.formData.mapping_list.length > 1 ? _c('a', {
          attrs: {
            "href": "javascript:",
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleRemove(index);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('删除')))]) : _vm._e()]);
      }
    }])
  }), _c('div', {
    staticStyle: {
      "border": "1px solid #e2e9f8",
      "border-top": "0px"
    }
  }, [_c('a-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isEdit,
      expression: "!isEdit"
    }],
    attrs: {
      "type": "link",
      "fbu-analyse-name": $t("+\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.t('+新增')))])], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };